import { Box, Divider, Typography } from '@mui/material';
import { useStyles } from '../styles';

export type SectionContainerProps = {
  title: string;
  children?: React.ReactNode;
  hideDivider?: true;
};

export const SectionContainer: React.FC<SectionContainerProps> = ({ title, children, hideDivider }) => {
  const { classes } = useStyles();

  return (
    <>
      <Box px={3} py={2} className={classes.sectionContainer}>
        <Box pb={1}>
          <Typography variant="overline" color="secondary">{title}</Typography>
        </Box>
        {children}
      </Box>
      {!hideDivider && (
        <Box my={0.5}>
          <Divider />
        </Box>
      )}
    </>
  );
};
